import { Injectable } from '@angular/core';

import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';

import { ClearUserStateAction, SetUserCountryAction } from './user.actions';

export interface UserStateModel {
  country: string | null;
}

const USER_STATE_TOKEN = new StateToken<UserStateModel>('user');

@State<UserStateModel>({
  name: USER_STATE_TOKEN,
  defaults: {
    country: null
  }
})
@Injectable()
export class UserState {
  @Selector([UserState]) static country(state: UserStateModel | undefined) {
    return state?.country ?? null;
  }

  @Action(SetUserCountryAction) setUserCountry(
    ctx: StateContext<UserStateModel>,
    { payload }: SetUserCountryAction
  ): void {
    ctx.patchState({
      country: payload
    });
  }

  @Action(ClearUserStateAction)
  clearState(ctx: StateContext<UserStateModel>): void {
    ctx.setState({
      country: null
    });
  }
}
